import { fetchOptions } from './csrf'

export interface DealerProfile {
  name: string
  email: string
  address: string
  address2: string
  city: string
  state: string
  zip: string
  timezone: string
  phone: string
  fax: string
  contact_email: string
  first_name: string
  last_name: string
  url: string
  gallery_url: string
  google_place_id: string
  social_fb_link: string
  social_tw_link: string
  social_li_link: string
  bg_complaint_contact: string
  business_hours: Record<string, { open: string; close: string } | null>
}

interface ProfileResponse {
  profile: DealerProfile
}

interface ProfileErrorResponse {
  errors: string[]
}

export const profileApi = {
  async getProfile(): Promise<DealerProfile> {
    const response = await fetch('/api/v1/profile', fetchOptions())
    if (!response.ok) {
      throw new Error('Failed to load profile')
    }
    const data: ProfileResponse = await response.json()
    return data.profile
  },

  async updateProfile(profile: Partial<DealerProfile>): Promise<DealerProfile> {
    const response = await fetch('/api/v1/profile', {
      ...fetchOptions('PUT'),
      body: JSON.stringify({ profile }),
    })
    if (!response.ok) {
      const data: ProfileErrorResponse = await response.json().catch(() => ({ errors: ['Failed to update profile'] }))
      throw new Error(data.errors.join(', '))
    }
    const data: ProfileResponse = await response.json()
    return data.profile
  },
}
